import animationData from 'lotties/events/loader.json';
import React from 'react';
import Lottie from 'react-lottie';

export default function LoaderV2({ height = '50px', width = '50px' }) {
    return (
        <Lottie
            options={{
                loop: true,
                autoplay: true,
                animationData,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                },
            }}
            height={height}
            width={width}
            isClickToPauseDisabled={true}
        />
    );
}
